import { Injectable } from '@angular/core';
import { DatatypesService } from 'pumpcalc-core/public-api';

export interface FieldChanger {
  changeNames: (obj: any) => any;
}

export interface NodeNamer {
  getNodeName: (obj: any) => string;
}

@Injectable({
  providedIn: 'root'
})
export class TreeListService {

  constructor() { }

  getTree(data: any[], fieldNamer: FieldChanger, nodeNamers: NodeNamer[]): any[] {
    let tree = [];
    data.forEach(item=>{
      item=fieldNamer.changeNames(item);
      this.addItemToNode(this.getNodeForPath(tree,this.path(item,nodeNamers)),item);
    })
    return tree;
  }

  getNodeForName(branch: any[], name: string): any {
    let result = null;
    branch.forEach(obj => {
      if (obj.text == name) { result = obj; }
    })
    if (!result) {
      branch.push({id:this.makeId(10),text:name,items:[]});
      return this.getNodeForName(branch,name)
    }
    return result;
  }

  addItemToNode(node: any, item: any) {
    node.items = node.items ? node.items : [];
    node.items.push(item);
  }

  clone(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }

  path(item: any, nodeNamers: NodeNamer[]): string[] {
    let path = [];
    nodeNamers.forEach(nodeNamer => {
      path.push(nodeNamer.getNodeName(item));
    })
    return path;
  }

  getNodeForPath(branch:any[],path:string[]){
    let result = this.getNodeForName(branch,path[0]);
    path.shift();
    return path.length>0?this.getNodeForPath(result.items,path):result;
  }

  addToPath(item: any, path: string[]) {
  }

  makeId(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }


}
